document.addEventListener('theme:cart:open', () => {
  //console.error('Cart Open')
  window.initSlick();
});
document.addEventListener('theme:cart:add', () => {
  //console.error('Cart Add')
  window.initSlick();
});
document.addEventListener('theme:cart:update', () => {
  //console.error('Cart Update')
  setInterval(() => {
    window.initSlick();
  }, 2000);
});
document.addEventListener('theme:cart:loaded', () => {
  //console.error('Cart Loaded')
  window.initSlick();
});

window.initSlick = function() {
  setTimeout(() => {
    const loader = document.getElementById('upsell-loader');
    const slider = document.getElementById('product-upsell-carousel');
    if (loader && !loader.classList.contains('hidden-loader')) {
      loader.classList.add('hidden-loader');
    }
    if (slider && slider.classList.contains('slick-initialized')) {
      //console.log('already slicked')
    } else {
      $('#product-upsell-carousel').slick({
        dots: false,
        appendDots: $('.upsell-dots'),
        arrows: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 1.08,
        autoplay: false,
        autoplaySpeed: 3000,
      });
    }
  }, 2000);
}
